export default __webpack_public_path__ + "static/media/Golden Ring of Dexterity.1ce27294.jpg";